"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequiredContext = void 0;
const react_1 = require("react");
function useRequiredContext(context) {
    const contextValue = (0, react_1.useContext)(context);
    if (Object.values(contextValue).some(x => x !== undefined)) {
        // some non-undefined values present on the context, pass through
        return contextValue;
    }
    throw new Error(`Missing a required context`);
}
exports.useRequiredContext = useRequiredContext;
//# sourceMappingURL=useRequiredContext.js.map